import { Box, Container, Stack, Typography } from "@mui/material";
import { PageCard } from "../components/page-cards";
import { routes } from "../utils/routes";

export const Home = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 6, mt: 4, textAlign: "center" }}>
        <Typography
          variant="h3"
          sx={{
            color: "#00f2ff",
            mb: 2,
            textShadow: "0 0 15px rgba(0, 242, 255, 0.4)",
            fontSize: { xs: "2rem", md: "3.5rem" },
            fontFamily: "'Syncopate', sans-serif",
            fontWeight: 700,
          }}
        >
          GALACTIC ARCHIVE
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "rgba(224, 250, 255, 0.6)",
            maxWidth: 600,
            mx: "auto",
            fontFamily: "'Orbitron', sans-serif",
            letterSpacing: "2px",
            fontSize: "0.8rem",
          }}
        >
          ACCESS AUTHORIZED. SELECT A DATA NODE TO COMMENCE RETRIEVAL.
        </Typography>
      </Box>
      <Stack
        direction="row"
        flexWrap="wrap"
        gap="2.5rem"
        justifyContent="center"
        sx={{ pb: 8 }}
      >
        {routes.map(
          (route) =>
            route.title !== "Home" && (
              <PageCard
                key={route.title}
                path={route.path}
                title={route.title}
                description={route.description ?? ""}
                image={route.image ?? ""}
              />
            ),
        )}
      </Stack>
    </Container>
  );
};
